// Module
var code = `{% liquid
  assign _product = _product | default: product
  assign regular_price = regular_price | default: _product.compare_at_price | default: _product.price | plus: 0
  # regular_price can be 0 at this point if compare_at_price was accidentally set to 0
  # set to the normal product price if so
  if regular_price == 0
    assign regular_price = _product.price | plus: 0
  endif
  assign sale_price = sale_price | default: _product.price | plus: 0
  assign regular_price_money = regular_price | money
  assign sale_price_money = sale_price | money
  assign sub_message = sub_message | default: nil
  # mode options: "main", "list", "compact", "secondary"
  assign mode = mode
  assign has_sale = false
  assign show_percentage_saved = show_percentage_saved | default: true, allow_false: true
  assign show_price_disclaimer = show_price_disclaimer | default: true, allow_false: true
  if sale_price and sale_price > 0 and regular_price > sale_price
    assign has_sale = true
  endif
  if settings.product_pricing_show_original_price_date and show_price_disclaimer and has_sale and _product.metafields.custom.last_compare_at_price_date
    assign display_asterisk = true
  endif
%}

<div
  class="product-price-v2__container product-price-v2__container--{{ mode }}"
  {% comment %}
    this data-product-id is used for price a/b testing
    this is removed in certain instances where we don't want the ui updated
    for example, in cart where a cart transformation function will update the price accordingly
  {% endcomment %}
  {% if _product.id %}
    data-product-id="{{ _product.id }}"
  {% endif %}
>
  <div class="product-price-v2__price-container">
    <div class="product-price-v2__regular-price {% if has_sale %}product-price-v2__regular-price--on-sale{% endif %}">
      <span class="product-price-v2__money" aria-label="regular price {{ regular_price_money }}">
        {{- regular_price_money -}}
      </span>
      {%- if display_asterisk -%}
        <span class="product-price-v2__asterisk">*</span>
      {%- endif -%}
    </div>
    {%- if has_sale -%}
      <div class="product-price-v2__sale-price">
        <span class="product-price-v2__money" aria-label="sale price {{ sale_price_money }}">
          {{- sale_price_money -}}
        </span>
        {%- if show_percentage_saved -%}
          {%- capture percentage_saved -%}
            {%- render 'percentage-saved', regular_price: regular_price, sale_price: sale_price -%}
          {%- endcapture -%}
          {%- if percentage_saved != blank -%}
            <span class="product-price-v2__percentage-saved {% unless settings.product_pricing_show_percentage_saved %}hidden{% endunless %}"
              >(
              {{- percentage_saved -}}
              )</span
            >
          {%- endif -%}
        {%- endif -%}
      </div>
    {%- endif -%}
  </div>
  {%- if sub_message and sub_message != blank -%}
    <p class="product-price-v2__sub-message">{{ sub_message }}</p>
  {%- endif -%}
</div>
`;
// Exports
export default code;